import Vue from "vue";
import { mapGetters } from "vuex";

import { LoadingSpinner } from "@/components";

import { formatDateTime, stringHelper } from "@/components/mixins";
import { ErrorLogService, GridUtil, PartDetailServices } from "@/services";

export default Vue.extend({
    name: "OrderHistoryTab",

    components: {
        LoadingSpinner,
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["user", "getContentItem", "hasPermission", "activeAccountId", "availableDealerCodes"]),
    },

    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
    },

    created() {
        this.orderColumns = GridUtil.localizeColumnLabels(this.orderColumns, this.getContentItem);
        this.invoiceColumns = GridUtil.localizeColumnLabels(this.invoiceColumns, this.getContentItem);
        this.backorderColumns = GridUtil.localizeColumnLabels(this.backorderColumns, this.getContentItem);
    },

    data: () => ({
        orderColumns: [
            { key: "OrderNumber", label: "Order Number" },
            { key: "DealerPurchaseOrder", label: "PO Number" },
            { key: "OrderDate", localizationKey: "Date", formatter: "getLocalDate" },
        ],
        invoiceColumns: [
            { key: "InvoiceNumber", localizationKey: "InvoiceNumber" },
            { key: "SalesOrderNumber", label: "Order Number" },
            { key: "InvoiceDate", localizationKey: "Date", formatter: "getLocalDate" },
        ],
        backorderColumns: [
            { key: "OrderNumber", label: "Order Number" },
            { key: "PurchaseOrderNumber", label: "PONumber" },
            { key: "TotalQuantityOrdered", localizationKey: "QuantityOrdered" },
            { key: "TotalQuantityBackordered", localizationKey: "QuantityBackordered" },
            { key: "PromisedShipDate", label: "Promised Date" }
        ],
        orders: [],
        invoices: [],
        backorders: [],
        loadingOrders: false,
        loadingInvoices: false,
        loadingBackorders: false,
        haveSuccessfullyLoadedOrders: false,
        haveSuccessfullyLoadedInvoices: false,
        haveSuccessfullyLoadedBackorders: false
    }),

    methods: {
        async getOrders() {
            try {
                this.loadingOrders = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    oemPartCode: this.oemPartCode,
                    stockFacingWarehouse: ""
                };

                var dealerCodes = [this.user.DealerCode];
                const data = await PartDetailServices.getOrderHistoryOrdersByOemPartCode(params, dealerCodes);

                this.orders = data;
                this.haveSuccessfullyLoadedOrders = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingOrders = false;
            }
        },
        async getInvoices() {
            try {
                this.loadingInvoices = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    oemPartCode: this.oemPartCode,
                    stockFacingWarehouse: ""
                };

                var dealerCodes = [this.user.DealerCode];      
                const data = await PartDetailServices.getOrderHistoryInvoicesByOemPartCode(params, dealerCodes);
                this.invoices = data;
                this.haveSuccessfullyLoadedInvoices = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingInvoices = false;
            }
        },
        async getBackorders() {
            try {
                this.loadingBackorders = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    oemPartCode: this.oemPartCode,
                    stockFacingWarehouse: ""
                };

                var dealerCodes = [this.user.DealerCode];
        
                const data = await PartDetailServices.getOrderHistoryBackordersByOemPartCode(params, dealerCodes);
                this.backorders = data;
                this.haveSuccessfullyLoadedBackorders = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingBackorders = false;
            }
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedOrders && !this.loadingOrders){
                this.getOrders();
            }
            if(!this.haveSuccessfullyLoadedInvoices && !this.loadingInvoices){
                this.getInvoices();
            }
            if(!this.haveSuccessfullyLoadedBackorders && !this.loadingBackorders){
                this.getBackorders();
            }
        }
    },
});
